import React, { useState, useEffect } from 'react';
import Select from 'react-select/async';
import _ from 'lodash';
import Services from '../services';
import { DatetimePicker } from '../../../commons/controls';
import moment, { relativeTimeThreshold } from 'moment';
import RFForm from '../../../components/Form/RFForm';
import TimeFormatter from '../../../commons/TimeFormatter';

const AjanlatFilter = props => {

  const {
    setFilter,
    children
  } = props;
  
  const [partner, setPartner] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState();

  useEffect(() => {
      setFilter(
        {
          partnerTortenetId: partner && partner.id,
          kezdete: startDate && TimeFormatter.formatDate(startDate),
          vege: endDate && TimeFormatter.formatDate(endDate),
        }
      );
  }, [startDate, endDate, partner]);

  const styles = {
    control: base => ({
      ...base,
      '&:focus': { borderColor: 'red' }, // border style on hover
      border: '1px solid lightgray', // default border color
      boxShadow: 'none', // no box-shadow
      borderRadius: '0'
    }),
  };

  const loadPartnerOptions = (input, callback) => {
    if(_.isEmpty(input)) callback([]);
    Services.listPartner({type: 'RENDELES_VEVOI_CIM_AKTIV_GET', text: input}, (err, res) => {
      if(!err){
        const options = res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase()))
        callback(options);
      }else{
        callback([]);
      }
    });
  }

  const handleDateInputChange = (e, v, name) => {
    const value = (v === '' || v === 'Invalid date') ? null : v;
    if (name === 'startDate') {
      setStartDate(value)
    } else if (name === 'endDate') {
      setEndDate(value);
    }
  }

  return(
      <RFForm onSubmit={() => {}}>
        <div className='row align-items-center'>
          <div className="col-md-2">
            <div style={{ marginBottom: 5 }}>
              <div className='labelmarginbottom'>Ügyfél: </div>
              <Select
                styles={styles}
                name="partner"
                id="partner"
                placeholder="Partner..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => setPartner(v)}
                loadOptions={_.debounce(loadPartnerOptions, 1000)}
                getOptionLabel={option => option.nev + ' (' + option.cim + ')'}
                getOptionValue={option => option.id}
                value={partner}
                isClearable
              />
            </div>
          </div>
          {/* <div className="col-auto align-self-center">Érvényesség kezdete:</div> */}
          <div className="col-md-2">
            <DatetimePicker
              label={'Érvényesség kezdete:'}
              id="startDate"
              name="startDate"
              value={startDate && new Date(startDate)}
              onChange={(e,v) => handleDateInputChange(e, v, 'startDate')}
              containerClassName="organw-date-time"
              time={false}
              // format="YYYY-MM-DD"
              messages={{ dateButton: "dátum" }}
            />
          </div>
          {/* <div className="col-auto align-self-center">Érvényesség vége:</div> */}
          <div className="col-md-2">
            <DatetimePicker
              label={'Érvényesség vége:'}
              id="endDate"
              name="endDate"
              value={endDate && new Date(endDate)}
              onChange={(e,v) => handleDateInputChange(e, v, 'endDate')}
              containerClassName="organw-date-time"
              time={false}
              // format="YYYY-MM-DD"
              messages={{ dateButton: "dátum" }}
            />
          </div>
          {children}
        </div>
    </RFForm>
  );
}

export default AjanlatFilter;